import { useState } from "react";
import Pagination from "../../components/Pagination";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import moment from "moment";
import AlertBox from "../../components/AlertBox";
import { useReactivationListHooks } from "../../utils/customer/ReactivationHooks";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import ModalDownloadReactivation from "../../components/customer/ModalDownloadReactivation";

const attachmentTypes = {
  speedtest: "Speedtest",
  handover_form: "Form Serah Terima",
  device_switch: "Perangkat & Switch",
};

export default function ReactivationReportPage() {
  let { hasAccess } = useControlPermission();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [showModalDownload, setShowModalDownload] = useState(false);
  let [filter, setFilter] = useState({
    q: "",
    page: 1,
    page_size: 10,
  });
  let [formFilter, setFormFilter] = useState({
    q: "",
  });

  let reactivationsData = useReactivationListHooks({ filter });

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  const onSubmitFilter = () => {
    setFilter({ ...filter, ...formFilter, page: 1 });
  };
  const onResetFilter = () => {
    setFormFilter({
      q: "",
    });
    setFilter({
      q: "",
      page: 1,
      page_size: 10,
    });
  };

  const downloadFile = async () => {
    setShowModalDownload(true);
  };

  const onSuccessDownload = (message) => {
    setAlert({ show: true, message: message, type: "success" });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <div className="mb-4">
          <div className="row">
            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">Report Reaktivasi Pelanggan</h1>
            </div>
            <div className="col-auto">
              {hasAccess("view-reactivation") && (
                <button className="btn btn-primary" onClick={() => downloadFile()}>
                  <i className="fas fa-download"></i> Unduh Report Reaktivasi
                </button>
              )}
            </div>
          </div>
        </div>
        <Box
          title={`Report Reaktivasi (Total: ${reactivationsData.meta.count})`}
          loading={reactivationsData.loading}
        >
          <div className="mb-4">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="cust_name">Pencarian</label>
                  <input
                    type="text"
                    className="form-control"
                    id="cust_name"
                    value={formFilter.q}
                    onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                  />
                </div>
              </div>
              <div className="col-md-auto" style={{ paddingTop: "32px" }}>
                <button className="btn btn-primary" onClick={() => onSubmitFilter()}>
                  Filter
                </button>
                <button className="btn btn-default" onClick={() => onResetFilter()}>
                  Reset
                </button>
              </div>
            </div>
          </div>
          <AlertBox {...alert} setAlert={setAlert} />
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Tgl. Reaktivasi</th>
                  <th>No. Pelanggan</th>
                  <th>Nama Pelanggan</th>
                  <th>No. Telepon</th>
                  <th>Teknisi</th>
                  <th>Helper</th>
                  <th>Catatan</th>
                  <th>Lampiran</th>
                </tr>
              </thead>
              <tbody>
                {reactivationsData.reactivations.length === 0 && (
                  <tr>
                    <td colSpan={8} className="text-center">
                      Tidak ada data yang ditampilkan
                    </td>
                  </tr>
                )}
                {reactivationsData.reactivations.map((reactivation, index) => (
                  <tr key={index}>
                    <td className="text-nowrap">
                      {moment(reactivation.reactivation_date).format("DD MMM YYYY")}
                    </td>
                    <td>{reactivation.customer?.customer_number || "-"}</td>
                    <td className="text-nowrap">{reactivation.customer?.name || "-"}</td>
                    <td>{reactivation.customer?.phone_number || "-"}</td>
                    <td className="text-nowrap">{reactivation.technician?.name || "-"}</td>
                    <td className="text-nowrap">{reactivation.helper?.name || "-"}</td>
                    <td>{reactivation.notes || "-"}</td>
                    <td className="text-nowrap">
                      {reactivation.attachments?.filter((attachment) => attachment.attachment_url)
                        .length > 0
                        ? reactivation.attachments
                            .filter((attachment) => attachment.attachment_url)
                            .map((attachment, i) => (
                              <a
                                key={i}
                                href={attachment.attachment_url}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-info mr-1"
                              >
                                <i className="fa fa-image"></i>{" "}
                                {attachmentTypes[attachment.type] || attachment.type}
                              </a>
                            ))
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {reactivationsData.meta.count > reactivationsData.meta.page_size && (
            <Pagination
              totalpage={Math.ceil(reactivationsData.meta.count / reactivationsData.meta.page_size)}
              selectedpage={reactivationsData.meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(reactivationsData.meta.page + 1)}
              prev={() => gotoPage(reactivationsData.meta.page - 1)}
            />
          )}
        </Box>

        <ModalDownloadReactivation
          show={showModalDownload}
          onClose={() => setShowModalDownload(false)}
          onSuccess={onSuccessDownload}
        />
      </div>
    </MainLayout>
  );
}
